import ControlModel from "../../models/controlModel";
import { MODEL_CONTROL_TYPE } from "../../utils/enums";

export function createBackControlModel({isShow}) {
  return new ControlModel({
    type: MODEL_CONTROL_TYPE.back,
    isShow: isShow
  });
}
